import classNames from "classnames";

export const Checkbox = ({
  children,
  className = "",
  checked,
  value,
  onClick,
  disabled = false,
  ...restProps
}) => {
  return (
    <button
      className={classNames(
        "btn-unstyled min-w-[72px] h-[40px] px-[24px] text-[14px] font-medium flex items-center justify-center border border-solid rounded-full transition mr-[12px] mb-[12px]",
        { "hover:border-[#FF2800] hover:text-[#FF2800]": !disabled },
        { "text-[#FF2800]": checked },
        checked
          ? "border-[#FF2800]"
          : disabled
          ? "border-[#F1F2F3] bg-[#F1F2F3] text-[#C9CCD0]"
          : "border-black",
        className
      )}
      onClick={() => {
        onClick(value);
      }}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
};
